export default (store, vuexNamespace) => (to, from, next) => {
  store
    .dispatch(
      (vuexNamespace ? vuexNamespace + "/" : "") + "oidcCheckAccess",
      to
    )
    .then((hasAccess) => {
      if (hasAccess) {
        next();
      } else {
        next("/login");
      }
    });
};
